import { render, staticRenderFns } from "./discharge-medicine-detail.vue?vue&type=template&id=759d63e5&scoped=true"
import script from "./discharge-medicine-detail.vue?vue&type=script&lang=js"
export * from "./discharge-medicine-detail.vue?vue&type=script&lang=js"
import style0 from "./discharge-medicine-detail.vue?vue&type=style&index=0&id=759d63e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759d63e5",
  null
  
)

export default component.exports